import fileDownload from 'js-file-download'
import { toJS } from 'mobx'
import ExcelJS from 'exceljs'

export const exportAssetStatisticsExcel = async (record, currentDate) => {
  try {
    const workbook = new ExcelJS.Workbook()
    const worksheet = workbook.addWorksheet('Thống kê tài sản')

    worksheet.getColumn('A').width = 5 //stt
    worksheet.getColumn('B').width = 40 // Tên dụng cụ
    worksheet.getColumn('C').width = 15 // đơn vị tính
    worksheet.getColumn('D').width = 15 // thuế
    worksheet.getColumn('E').width = 25 // đơn giá trước thuế
    worksheet.getColumn('F').width = 25 // đơn giá sau thuế
    worksheet.getColumn('G').width = 25 // tồn đầu kỳ
    worksheet.getColumn('H').width = 25 // nhập trong kỳ
    worksheet.getColumn('I').width = 25 // xuất trong kỳ
    worksheet.getColumn('J').width = 20 // tồn cuối kỳ - số lượng
    worksheet.getColumn('K').width = 25 // thành tiền trước thuế
    worksheet.getColumn('L').width = 25 // thành tiền sau thuế

    // Thêm tiêu đề và các thông tin khác
    worksheet.mergeCells('A1:L1')
    worksheet.getCell(
      'A1'
    ).value = `THỐNG KÊ NHẬP XUẤT TỒN VĂN PHÒNG PHẨM THÁNG ${currentDate}`
    worksheet.getCell('A1').alignment = {
      vertical: 'middle',
      horizontal: 'center',
    }
    worksheet.getCell('A1').font = { size: 14, bold: true }
    worksheet.getCell('A2').value = ''

    const headerNameRowOne = [
      'Số TT',
      'Tên dụng cụ, văn phòng phẩm',
      'Đơn vị tính',
      'Thuế',
      'Đơn giá trước thuế',
      'Đơn giá sau thuế',
      'Tồn đầu kỳ (Số lượng)',
      'Nhập trong kỳ (Số lượng)',
      'Xuất trong kỳ (Số lượng)',
      'Tồn cuối kỳ',
      '',
      '',
    ]
    const headerNameRowTwo = [
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      '',
      'Số lượng',
      'Thành tiền trước thuế',
      'Thành tiền sau thuế',
    ]

    worksheet.addRow(headerNameRowOne)
    worksheet.addRow(headerNameRowTwo)
    worksheet.mergeCells('A3:A4')
    worksheet.mergeCells('B3:B4')
    worksheet.mergeCells('C3:C4')
    worksheet.mergeCells('D3:D4')
    worksheet.mergeCells('E3:E4')
    worksheet.mergeCells('F3:F4')
    worksheet.mergeCells('G3:G4')
    worksheet.mergeCells('H3:H4')
    worksheet.mergeCells('I3:I4')

    worksheet.mergeCells('J3:L3') // Merging for 'Phí sửa chữa CONT (hạng mục thu)'

    // Áp dụng border cho các ô tiêu đề
    const borderStyle = {
      top: { style: 'thin' },
      left: { style: 'thin' },
      bottom: { style: 'thin' },
      right: { style: 'thin' },
    }

    // Áp dụng border cho từng ô trong dòng tiêu đề đầu tiên
    headerNameRowOne.forEach((_, colIndex) => {
      // @ts-ignore
      worksheet.getCell(3, colIndex + 1).border = borderStyle
      worksheet.getRow(3).alignment = {
        vertical: 'middle',
        horizontal: 'center',
      }
      worksheet.getRow(3).font = { bold: true }
    })

    // Áp dụng border cho từng ô trong dòng tiêu đề thứ hai
    headerNameRowTwo.forEach((_, colIndex) => {
      // @ts-ignore
      worksheet.getCell(4, colIndex + 1).border = borderStyle
      worksheet.getRow(4).alignment = {
        vertical: 'middle',
        horizontal: 'center',
      }
      worksheet.getRow(4).font = { bold: true }
    })

    if (Array.isArray(record?.data)) {
      record.data.forEach((item, index) => {
        const openingBalanceItem = item?.assetHistories?.reduce(
          (selectedItem, item) => {
            const itemDate = new Date(item?.createAt)
            const [compareMonth, compareYear] = currentDate.split('-')
            const currentDateObject = new Date(compareYear, compareMonth - 1)
            if (
              item?.type === 'LASTMONTH' &&
              (itemDate.getFullYear() < currentDateObject.getFullYear() ||
                (itemDate.getFullYear() === currentDateObject.getFullYear() &&
                  itemDate.getMonth() < currentDateObject.getMonth()))
            ) {
              if (
                !selectedItem ||
                new Date(item.createAt) < new Date(selectedItem.createAt)
              ) {
                return item
              }
            }
            return selectedItem
          },
          null
        )
        const openingBalanceQuantity = openingBalanceItem
          ? openingBalanceItem.quantity
          : 0

        const periodImportQuantity = item?.assetHistories?.reduce(
          (quantity, imports) => {
            if (imports?.type === 'CREATE' || imports?.type === 'UPDATE') {
              quantity += imports.quantity
            }
            return quantity
          },
          0
        )
        const periodExportQuantity = item?.assetHistories?.reduce(
          (quantity, exports) => {
            if (exports?.type === 'EXPORT') {
              quantity += exports.quantity
            }
            return quantity
          },
          0
        )
        const calculateAssetStatistics = record => {
          const itemLastMonth = record?.assetHistories?.filter(item => {
            const itemDate = new Date(item?.createAt)
            const [compareMonth, compareYear] = currentDate.split('-')
            const currentDateObject = new Date(compareYear, compareMonth - 1)
            return (
              item?.type === 'LASTMONTH' &&
              (itemDate.getFullYear() < currentDateObject.getFullYear() ||
                (itemDate.getFullYear() === currentDateObject.getFullYear() &&
                  itemDate.getMonth() < currentDateObject.getMonth()))
            )
          })

          const itemCreate = record?.assetHistories?.filter(
            item => item?.type === 'CREATE'
          )
          const itemUpdate = record?.assetHistories?.filter(
            item => item?.type === 'UPDATE'
          )
          const itemExport = record?.assetHistories?.filter(
            item => item?.type === 'EXPORT'
          )

          const totalLastMonth = itemLastMonth.reduce(
            (total, item) => total + item.quantity,
            0
          )
          const totalCreate = itemCreate.reduce(
            (total, item) => total + item.quantity,
            0
          )
          const totalUpdate = itemUpdate.reduce(
            (total, item) => total + item.quantity,
            0
          )
          const totalExport = itemExport.reduce(
            (total, item) => total + item.quantity,
            0
          )
          let finalTotal = 0
          let totalMoney = 0
          let totalMoneyTax = 0

          const [compareMonth, compareYear] = currentDate.split('-')
          const currentDateObject = new Date(compareYear, compareMonth - 1)

          const now = new Date()
          const currentMonthYearObject = new Date(
            now.getFullYear(),
            now.getMonth()
          )

          const itemUpdateLast = record?.assetHistories
            ?.filter(item => item?.type !== 'LASTMONTH')
            .reduce((latestItem, currentItem) => {
              if (
                !latestItem ||
                new Date(currentItem.createAt) > new Date(latestItem.createAt)
              ) {
                return currentItem
              }
              return latestItem
            }, null)

          if (currentDateObject < currentMonthYearObject) {
            finalTotal =
              totalLastMonth + totalCreate + totalUpdate - totalExport
            totalMoney = Number(finalTotal) * Number(itemUpdateLast?.price)
            totalMoneyTax =
              Number(finalTotal) * Number(itemUpdateLast?.totalMoney)
          }

          return {
            finalTotal,
            totalMoney,
            totalMoneyTax,
            itemUpdateLast,
          }
        }
        const data = [
          index + 1,
          item?.asset?.assetName,
          item?.asset?.assetUnitName,
          calculateAssetStatistics(item).itemUpdateLast?.tax
            ? `${calculateAssetStatistics(item).itemUpdateLast.tax}%`
            : '----',
          calculateAssetStatistics(item).itemUpdateLast
            ? parseFloat(
                calculateAssetStatistics(item).itemUpdateLast.price
              ).toLocaleString('vi-VN')
            : '----',
          calculateAssetStatistics(item).itemUpdateLast
            ? parseFloat(
                calculateAssetStatistics(item).itemUpdateLast.totalMoney
              ).toLocaleString('vi-VN')
            : '----',
          openingBalanceQuantity,
          periodImportQuantity,
          periodExportQuantity,
          calculateAssetStatistics(item)
            ? calculateAssetStatistics(item).finalTotal
            : '----',
          calculateAssetStatistics(item)
            ? calculateAssetStatistics(item).totalMoney.toLocaleString('vi-VN')
            : '----',
          calculateAssetStatistics(item)
            ? calculateAssetStatistics(item).totalMoneyTax.toLocaleString(
                'vi-VN'
              )
            : '----',
        ]
        const rowItem = worksheet.addRow(data)
        rowItem.eachCell({ includeEmpty: true }, cell => {
          // @ts-ignore
          cell.border = borderStyle
          cell.alignment = { vertical: 'middle', horizontal: 'center' }
        })
      })
    } else {
      console.error('record.data is not an array or is undefined')
    }

    const date = new Date()
    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const year = date.getFullYear()
    const filename = `Thong_ke_tai_san_${day}_${month}_${year}.xlsx`
    const buffer = await workbook.xlsx.writeBuffer()
    fileDownload(buffer, filename)
  } catch (error) {
    console.log('export asset statistic excel', error)
  }
}
